/**
 * Transaction Metadata client utility.
 *
 * Usage:
 *   import { updateTransactionMetadata } from '../features/transactionMetadata';
 *   await updateTransactionMetadata('tx-id-123', { callRecordingUrl: '...', notes: '...' });
 */

/**
 * Update metadata on a transaction.
 *
 * @param {string} transactionId
 * @param {Object} metadata - key/value pairs to merge into transaction.metadata
 * @returns {Promise<Object>}
 */
export const updateTransactionMetadata = async (transactionId, metadata) => {
  const res = await fetch('/api/tx/metadata', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ transactionId, ...metadata }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Failed to update transaction metadata');
  }

  return res.json();
};
